/* eslint-disable no-new-func */
import { IAdvancedStore } from '@mihanizm56/redux-core-modules';
import {
  setFetchPermissionsListener,
  setFetchUserDataListener,
  setRefreshPermissionsListener,
} from '@wildberries/databus-service-user';
import {
  setFetchProductsListener,
  NavigateToRouteParamsType,
  setNavigateProductListener,
  setPrefetchProductListener,
  PrefetchProductParamsType,
} from '@wildberries/databus-service-products';
import {
  FetchMenuActionPayloadType,
  fetchMenuActionSaga,
  navigateToProductActionSaga,
  preloadRouteAction,
} from '@wildberries/service-products';
import {
  fetchUserInfoAction,
  fetchUserPermissionsAction,
  FetchUserPermissionsActionPayloadType,
  getUserInfo,
  getUserPermissions,
  refreshUserFeaturesActionSaga,
  RefreshUserFeaturesType,
} from '@wildberries/service-user';
import { getMainMenuRequestConfig } from '@/_utils/get-main-menu-request-config';
import { getCookie } from '@/_utils/init-app/_utils/get-cookie';
import { getAbacRequestParams } from '@/_utils/get-abac-request-params';
import { getUserInfoCacheConfig } from '@/_utils/api-cache/configs/user-info-cache-config';
import { getFetchMenuCacheKey } from '@/_utils/api-cache/configs/get-fetch-menu-cache-key';

const ROOT_ABAC_FEATURES = (window.ENVS.ROOT_ABAC_FEATURES ||
  []) as Array<string>;
const MAIN_ABAC_SCOPE = window.ENVS.MAIN_ABAC_SCOPE || '';

export const initDatabusSubscriptions = (store: IAdvancedStore) => {
  setFetchProductsListener((actionParams: FetchMenuActionPayloadType) => {
    const { id: userId } = getUserInfo(store.getState() as never);
    const permissions = getUserPermissions(store.getState(), MAIN_ABAC_SCOPE);

    const fetchMenuCacheKey = getFetchMenuCacheKey({ getCookie }).key;
    const fetchMenuConfig = getMainMenuRequestConfig({
      cacheKey: fetchMenuCacheKey,
      userId,
      menuFromFileRequest:
        !('menuTakenFromFile' in permissions) || permissions.menuTakenFromFile,
      // feature to switch default merging
      // todo rename feature
      defaultShown:
        !('activeSupplier' in permissions) || permissions.activeSupplier,
    });

    const fetchMenuActionSagaParams: FetchMenuActionPayloadType =
      permissions?.menuTakenFromFile
        ? {
            ...actionParams,
            configs: fetchMenuConfig,
            permissions,
          }
        : {
            ...actionParams,
            configs: fetchMenuConfig,
          };

    store.dispatch(fetchMenuActionSaga(fetchMenuActionSagaParams));
  });

  setFetchUserDataListener(() => {
    const { id: userId } = getUserInfo(store.getState() as never);
    const browserCacheParams = userId
      ? getUserInfoCacheConfig({ userId })
      : null;

    store.dispatch(
      fetchUserInfoAction({
        browserCacheParams,
      }),
    );
  });

  setFetchPermissionsListener(
    (actionParams: FetchUserPermissionsActionPayloadType) => {
      const { id: userId } = getUserInfo(store.getState() as never);

      const { browserCacheParams, featuresFilterList, key } =
        getAbacRequestParams({
          getCookie,
          userId,
          featuresFilterList: ROOT_ABAC_FEATURES,
        });

      const fetchUserPermissionsParams = {
        ...actionParams,
        scope: window.ENVS.MAIN_ABAC_SCOPE,
        browserCacheParams,
        featuresFilterList,
      };

      store.dispatch(
        fetchUserPermissionsAction(
          key
            ? { ...fetchUserPermissionsParams, key }
            : fetchUserPermissionsParams,
        ),
      );
    },
  );

  setRefreshPermissionsListener((actionParams: RefreshUserFeaturesType) => {
    store.dispatch(refreshUserFeaturesActionSaga(actionParams));
  });

  setNavigateProductListener((params: NavigateToRouteParamsType) => {
    store.dispatch(navigateToProductActionSaga(params));
  });

  setPrefetchProductListener((params: PrefetchProductParamsType) => {
    store.dispatch(preloadRouteAction(params));
  });
};
